import React, {  useState } from 'react'
import eclipse from "../../assets/images/eclipse.png"
import eclipseselecetd from "../../assets/images/eclipseselected.png"
import ObserverCard from './ObserverCard/ObserverCard'
import DialogComp from './DialogComp/DialogComp'
const ObservList = ({observatoires}) => {
    const [open, setOpen] = useState(false)
    const [filteredObservatoire, setFilteredObservatoire] = useState([])
    const [selectedFilter, setSelectedFilter] = useState("")
    const [currentObs, setcurrentObs] = useState({
        name:"",
        role:"",
        bio:"",
        fb:"",
        lin:"",
        imgPath:"",
    })
    const handleOpen = () => {
        setOpen(true);
      };
      const filterByOccupation = (occupation) => {
        const filtered = observatoires.filter(obs => obs.occupation.toLowerCase() === occupation);
        setSelectedFilter(occupation);
        setFilteredObservatoire(filtered);
      };
      
      return (
        <div className='pt-14 px-4 md:px-8 pb-8 grid justify-center gap-8'>
          <div className='grid justify-center text-center gap-6'>
            <h1 className='text-2xl md:text-4xl text-[#54B3FF] font-semibold'>Les observatoires</h1>
            <h2 className='text-3xl md:text-5xl text-[#006DC4] uppercase'>Du Gireausol</h2>
            <div className='grid grid-cols-2 md:grid-cols-5 gap-4'>
              <div
                className='flex items-center justify-center space-x-2 md:space-x-4 cursor-pointer'
                onClick={() => { filterByOccupation("entreprise") }}>
                {selectedFilter === "entreprise" ? (
                  <img className='  h-4 md:h-5 w-4 md:w-5' src={eclipseselecetd} alt="someimg" />
                ) : (
                  <img className='h-4 md:h-5 w-4 md:w-5' src={eclipse} alt="someimg" />
                )}
                <span className='text-xs md:text-base'>Entreprise</span>
              </div>
      
              <div
                className='flex items-center justify-center space-x-2 md:space-x-4 cursor-pointer'
                onClick={() => { filterByOccupation("chercheur") }}>
                {selectedFilter === "chercheur" ? (
                  <img className='h-4 md:h-5 w-4 md:w-5' src={eclipseselecetd} alt="someimg" />
                ) : (
                  <img className='h-4 md:h-5 w-4 md:w-5' src={eclipse} alt="someimg" />
                )}
                <span className='text-xs md:text-base'>Chercheur</span>
              </div>
      
              <div
                className='flex items-center justify-center space-x-2 md:space-x-4 cursor-pointer'
                onClick={() => { filterByOccupation("etudiant") }}>
                {selectedFilter === "etudiant" ? (
                  <img className='h-4 md:h-5 w-4 md:w-5' src={eclipseselecetd} alt="someimg" />
                ) : (
                  <img className='h-4 md:h-5 w-4 md:w-5' src={eclipse} alt="someimg" />
                )}
                <span className='text-xs md:text-base'>Etudiant</span>
              </div>
      
              <div
                className='flex items-center justify-center space-x-2 md:space-x-4 cursor-pointer'
                onClick={() => { filterByOccupation("membre") }}>
                {selectedFilter === "membre" ? (
                  <img className='h-4 md:h-5 w-4 md:w-5' src={eclipseselecetd} alt="someimg" />
                ) : (
                  <img className='h-4 md:h-5 w-4 md:w-5' src={eclipse} alt="someimg" />
                )}
                <span className='text-xs md:text-base'>Membre de l'AEDS</span>
              </div>
      
              <div
                className='flex items-center justify-center space-x-2 md:space-x-4 cursor-pointer'
                onClick={() => { filterByOccupation("") }}>
                {selectedFilter === "" ? (
                  <img className='h-4 md:h-5 w-4 md:w-5' src={eclipseselecetd} alt="someimg" />
                ) : (
                  <img className='h-4 md:h-5 w-4 md:w-5' src={eclipse} alt="someimg" />
                )}
                <span className='text-xs md:text-base'>All</span>
              </div>
            </div>
          </div>
      
          <div className='grid grid-cols-1 md:grid-cols-4 gap-12 md:gap-24'>
            {selectedFilter !== "" ? (
              filteredObservatoire &&
              filteredObservatoire.map((e, i) => (
                <ObserverCard
                  key={i}
                  setCurrentObs={setcurrentObs}
                  handleOpen={handleOpen}
                  occupation={e.occupation}
                  description={e.description}
                  name={e.name}
                  role={e.role}
                  bio={e.bio}
                  imgPath={e.picture.asset._ref}
                  face={e.fb}
                  lin={e.lin}
                />
              ))
            ) : (
              observatoires &&
              observatoires.map((e, i) => (
                <ObserverCard
                  key={i}
                  setCurrentObs={setcurrentObs}
                  handleOpen={handleOpen}
                  occupation={e.occupation}
                  description={e.description}
                  name={e.name}
                  role={e.role}
                  bio={e.bio}
                  imgPath={e.picture.asset._ref}
                  face={e.fb}
                  lin={e.lin}
                />
              ))
            )}
            <DialogComp currentObs={currentObs} open={open} setOpen={setOpen} />
          </div>
        </div>
      );
      
}

export default ObservList